import { render } from "./CoachDetails.vue?vue&type=template&id=d7899b5a"
import script from "./CoachDetails.vue?vue&type=script&lang=js"
export * from "./CoachDetails.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Vue\\Course\\Section16\\main-prj-01-starting-setup\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__